import {properties} from './properties';

export const environment = {
    clientBannerHeader: properties.clientBannerHeader,
    oktaRedirectUri: properties.oktaRedirectUri,
    oktaRedirectUriImplict: properties.oktaRedirectUriImplict,
    oktaRedirectUriConfirmation: properties.oktaRedirectUriConfirmation,
    erumsRedirectCookieName: properties.erumsRedirectCookieName,
    tooltips: properties.tooltips,
    bannerConfiguration: properties.bannerConfiguration,
    PromoTypeDescription: properties.PromoTypeDescription,
    lastLoginAllowedTime: properties.timer.lastLoginAllowedTime,
    authApi: '/bin/safeway/unified/userinfo?banner={banner}',
    SSO_URL: '/bin/safeway/sso',
    SIGN_IN_URL: '/account/sign-in.html',
    RE_SIGN_IN_URL: '/account/re-sign-in.html',
    LEFT_NAV_API: '/bin/safeway/ucanavigation?banner={banner}',
    featureFlagURL: '/content/experience-fragments/featureflags/featureflags.caas.json',
    qa1: {
        currentEnv: 'qa1',
        displayAds: true,
        sponsoredContentSendChannel: true,
        sponsoredContentSendChannelV2: true,
        fullBannerV2Flag: true,
        showSponsoredText: true,
        topAdType: 'full',
        bottomAdType: 'full',
        aemSponsoredBannerURL: '/content/experience-fragments/www/{banner}/en/generic_content/weeklyads-poc/home.html',
        production: false,
        clientBannerHeader: properties.clientBannerHeader,
        oktaRedirectUri: properties.oktaRedirectUri,
        oktaRedirectUriImplict: properties.oktaRedirectUriImplict,
        oktaRedirectUriConfirmation: properties.oktaRedirectUriConfirmation,
        erumsRedirectCookieName: properties.erumsRedirectCookieName,
        tooltips: properties.tooltips,
        PromoTypeDescription: properties.PromoTypeDescription,
        lastLoginAllowedTime: properties.timer.lastLoginAllowedTime,
        cartUrl: '/erums/cart/',
        checkoutUrl: '/ecom/checkout/modern1/clientcheckout',
        ordersUrl: '/account/orders.html',
        LEFT_NAV_API: '/bin/safeway/ucanavigation?banner={banner}',

        API_HEADERS_GET_STORES: {
            'Ocp-Apim-Subscription-Key': '8ca6295a55f54368844b5982edc1cc01',
            'x-swy_banner': '{banner}',
            'x-swy-client-id': 'web-portal',
        },
        CHECK_USER_ACTIVE_SESSION: false,
        greyDownURL: '/erums/store/dist/assets/images/grey_down_2X.png',
        greyUpURL: '/erums/store/dist/assets/images/grey_up_2X.png',
        storeLookupConfig: {
            storeDetailsAPI: '/api/services/locator/entity/store/',
            zipCodeLookupAPI: '/api/services/locator/store/delivery',
            pickupStoreAPI: '/api/services/locator/store/pickup',
            header: {
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': '28291c6a4d7f436f8a8e279702bd2655'
            }
        },
        disableMyList: {},
        enableShareAd: true,
        enablePrintAd: true,
        printURL: 'https://api.flipp.com/flyerkit/v4.0/publications/',
        printLocale: 'en-US',
        offerDetailsURL: '/abs/qapub/dce/gallery/J4UProgram1/services/gallery/offers/offerDefinitionByOfferIds?storeId={storeid}',
        adobeImageURL: 'https://images.albertsons-media.com/is/image/ABSStage/',
        imagePath: '//images.albertsons-media.com/is/image/ABSStage/${product.id}?$ecom-product-card-${viewport}-jpg$&defaultImage=Not_Available',
        leftNavigation: '/content/experience-fragments/www/for_u/navigation/master.caas.json',
        getPrograms: '/abs/qapub/ocgp/gamification/internal/programs',
        prizes: "/abs/qapub/ocgp/gamification/internal/prizes",
        gameActivity: "/abs/qapub/ocgp/gamification/internal/prizes/game/activity",
        postGameDetails: "/abs/qapub/ocgp/gamification/internal/gameplay/postgamedetails",
        userGameActivity: "/abs/qapub/ocgp/gamification/internal/prizes/{uuid}/game/activity",
        redemption: "/abs/qapub/ocgp/gamification/internal/redemption",
        sweepstakeWinner: "/abs/qapub/ocgp/gamification/internal/sweepstake/winner",
        userPrizeTransactions: "/abs/qapub/ocgp/gamification/internal/prizes/{uuid}/transactions",
        programPoints: "/abs/qapub/ocgp/gamification/internal/program/points",
        optin: "/abs/qapub/ocgp/gamification/internal/gameplay/optin",
        sweepstakesWinDisplay: "/abs/qapub/ocgp/gamification/internal/update/sweepstakes/wins",
        getprofileAddressPath: "/abs/qapub/cnc/ucaservice/api/uca/customers/{customerId}/profile",
        ocrpRewardsTransactionEndpoint: '/abs/qapub/xapi/ocrp/rewards/transactionhistory',
        ocgpRewardsTransactionEndpoint: '/abs/qapub/ocgp/gamification/internal/prizes/transactions/history',
        storeResolverZipToCityEndpoint: '/abs/qapub/xapi/storeresolver/zipcodetocity',
        howItWorks: '/abs/qapub/ocgp/gamification/internal/update/howitworks',
        gamesAPIHeaders: {
            getProgram: {
                'Accept': 'application/vnd.safeway.v1+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': '02a0846aa2fa4df8a4192b2d8da5fb42',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-id': 'web-portal',
                'x-swy_banner': '{banner}',
                'cache-control': 'no-cache',
                'client-name': 'webui',
                'Entry': 'web'
            },
            xAPIOcrpRewardsHttpOptions: {
                'Content-Type': 'application/vnd.safeway.v1+json',
                'ocp-apim-subscription-key': 'da77a6845488408ba1db8d8d39237043'
            },
            xAPIOcrpRewardsHttpOptionsV2: {
                'Content-Type': 'application/vnd.safeway.v2+json',
                'ocp-apim-subscription-key': 'da77a6845488408ba1db8d8d39237043'
            },
            xAPIOcgpRewardsHttpOptions: {
                'Entry': 'web',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'ocp-apim-subscription-key': '02a0846aa2fa4df8a4192b2d8da5fb42'
            },
            xAPIstoreResolverHttpOptions: {
                'ocp-apim-subscription-key': '8ca6295a55f54368844b5982edc1cc01'
            }
        },
        gamesUCAHeaders: {
            getProfile: {
                'Accept': 'application/vnd.safeway.v3+json',
                'Cache-Control': 'no-cache',
                'Content-Type': 'application/vnd.safeway.v3+json',
                'ocp-Apim-Subscription-Key': 'b63410670d33422186409d4ad55c9030',
                'x-swy-banner': '{banner}',
                'x-swy-client-id': 'web-portal',
                'x-swy-client-name': 'web-portal',
            }
        }
    },
    qa2: {
        currentEnv: 'qa2',
        displayAds: true,
        sponsoredContentSendChannel: true,
        sponsoredContentSendChannelV2: true,
        fullBannerV2Flag: true,
        showSponsoredText: true,
        topAdType: 'full',
        bottomAdType: 'full',
        aemSponsoredBannerURL: '/content/experience-fragments/www/{banner}/en/generic_content/weeklyads-poc/home.html',
        production: false,
        clientBannerHeader: properties.clientBannerHeader,
        oktaRedirectUri: properties.oktaRedirectUri,
        oktaRedirectUriImplict: properties.oktaRedirectUriImplict,
        oktaRedirectUriConfirmation: properties.oktaRedirectUriConfirmation,
        erumsRedirectCookieName: properties.erumsRedirectCookieName,
        tooltips: properties.tooltips,
        PromoTypeDescription: properties.PromoTypeDescription,
        lastLoginAllowedTime: properties.timer.lastLoginAllowedTime,
        cartUrl: '/erums/cart/',
        checkoutUrl: '/ecom/checkout/modern1/clientcheckout',
        ordersUrl: '/account/orders.html',
        LEFT_NAV_API: '/bin/safeway/ucanavigation?banner={banner}',

        API_HEADERS_GET_STORES: {
            'Ocp-Apim-Subscription-Key': '35570fd5f27f4d69948bafbb4dd4f878',
            'x-swy_banner': '{banner}',
            'x-swy-client-id': 'web-portal',
        },
        CHECK_USER_ACTIVE_SESSION: false,
        greyDownURL: '/erums/store/dist/assets/images/grey_down_2X.png',
        greyUpURL: '/erums/store/dist/assets/images/grey_up_2X.png',
        storeLookupConfig: {
            storeDetailsAPI: '/api/services/locator/entity/store/',
            zipCodeLookupAPI: '/api/services/locator/store/delivery',
            pickupStoreAPI: '/api/services/locator/store/pickup',
            header: {
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': '28291c6a4d7f436f8a8e279702bd2655'
            }
        },
        disableMyList: {},
        enableShareAd: true,
        enablePrintAd: true,
        printURL: 'https://api.flipp.com/flyerkit/v4.0/publications/',
        printLocale: 'en-US',
        featureFlagURL: '/content/experience-fragments/featureflags/featureflags.caas.json',
        offerDetailsURL: '/abs/qapub/dce/gallery/J4UProgram1/services/gallery/offers/offerDefinitionByOfferIds?storeId={storeid}',
        adobeImageURL: 'https://images.albertsons-media.com/is/image/ABS/',
        imagePath: '//images.albertsons-media.com/is/image/ABS/${product.id}?$ecom-product-card-${viewport}-jpg$&defaultImage=Not_Available',
        leftNavigation: '/content/experience-fragments/www/for_u/navigation/master.caas.json',
        getPrograms: '/abs/acceptancepub/ocgp/gamification/internal/programs',
        prizes: "/abs/acceptancepub/ocgp/gamification/internal/prizes",
        gameActivity: "/abs/acceptancepub/ocgp/gamification/internal/prizes/game/activity",
        postGameDetails: "/abs/acceptancepub/ocgp/gamification/internal/gameplay/postgamedetails",
        userGameActivity: "/abs/acceptancepub/ocgp/gamification/internal/prizes/{uuid}/game/activity",
        redemption: "/abs/acceptancepub/ocgp/gamification/internal/redemption",
        sweepstakeWinner: "/abs/acceptancepub/ocgp/gamification/internal/sweepstake/winner",
        userPrizeTransactions: "/abs/acceptancepub/ocgp/gamification/internal/prizes/{uuid}/transactions",
        programPoints: "/abs/acceptancepub/ocgp/gamification/internal/program/points",
        optin: "/abs/acceptancepub/ocgp/gamification/internal/gameplay/optin",
        sweepstakesWinDisplay: "/abs/acceptancepub/ocgp/gamification/internal/update/sweepstakes/wins",
        getprofileAddressPath: "/abs/acceptancepub/cnc/ucaservice/api/uca/customers/{customerId}/profile",
        ocrpRewardsTransactionEndpoint: '/abs/acceptancepub/xapi/ocrp/rewards/transactionhistory',
        ocgpRewardsTransactionEndpoint: '/abs/acceptancepub/ocgp/gamification/internal/prizes/transactions/history',
        storeResolverZipToCityEndpoint: '/abs/acceptancepub/xapi/storeresolver/zipcodetocity',
        howItWorks: '/abs/acceptancepub/ocgp/gamification/internal/update/howitworks',
        gamesAPIHeaders: {
            getProgram: {
                'Accept': 'application/vnd.safeway.v1+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': '19ef5e3970f644a8abcffd28068f022e',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-id': 'web-portal',
                'x-swy-client-name': 'web-portal',
                'x-swy_banner': '{banner}',
                'cache-control': 'no-cache',
                'client-name': 'webui',
                'Entry': 'web'
            },
            xAPIOcrpRewardsHttpOptions: {
                'Content-Type': 'application/vnd.safeway.v1+json',
                'ocp-apim-subscription-key': 'B64bee335e314def9fd3e33435604ad4'
            },
            xAPIOcrpRewardsHttpOptionsV2: {
                'Content-Type': 'application/vnd.safeway.v2+json',
                'ocp-apim-subscription-key': 'B64bee335e314def9fd3e33435604ad4'
            },
            xAPIOcgpRewardsHttpOptions: {
                'Entry': 'web',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'ocp-apim-subscription-key': '19ef5e3970f644a8abcffd28068f022e'
            },
            xAPIstoreResolverHttpOptions: {
                'ocp-apim-subscription-key': '35570fd5f27f4d69948bafbb4dd4f878'
            }
        },
        gamesUCAHeaders: {
            getProfile: {
                'Accept': 'application/vnd.safeway.v3+json',
                'Cache-Control': 'no-cache',
                'Content-Type': 'application/vnd.safeway.v3+json',
                'ocp-Apim-Subscription-Key': 'e5b1bf4a9c124561ba364ac53c2cbc66',
                'x-swy-banner': '{banner}',
                'x-swy-client-id': 'web-portal',
                'x-swy-client-name': 'web-portal',
            }
        }
    },
    qa3: {
        currentEnv: 'qa3',
        displayAds: true,
        sponsoredContentSendChannel: true,
        sponsoredContentSendChannelV2: true,
        fullBannerV2Flag: true,
        showSponsoredText: true,
        topAdType: 'full',
        bottomAdType: 'full',
        aemSponsoredBannerURL: '/content/experience-fragments/www/{banner}/en/generic_content/weeklyads-poc/home.html',
        production: false,
        clientBannerHeader: properties.clientBannerHeader,
        oktaRedirectUri: properties.oktaRedirectUri,
        oktaRedirectUriImplict: properties.oktaRedirectUriImplict,
        oktaRedirectUriConfirmation: properties.oktaRedirectUriConfirmation,
        erumsRedirectCookieName: properties.erumsRedirectCookieName,
        tooltips: properties.tooltips,
        PromoTypeDescription: properties.PromoTypeDescription,
        lastLoginAllowedTime: properties.timer.lastLoginAllowedTime,
        cartUrl: '/erums/cart/',
        checkoutUrl: '/ecom/checkout/modern1/clientcheckout',
        ordersUrl: '/account/orders.html',
        LEFT_NAV_API: '/bin/safeway/ucanavigation?banner={banner}',

        API_HEADERS_GET_STORES: {
            'Ocp-Apim-Subscription-Key': '6eb4decfcd01473aa5ee0a690cc39006',
            'x-swy_banner': '{banner}',
            'x-swy-client-id': 'web-portal',
        },
        CHECK_USER_ACTIVE_SESSION: false,
        greyDownURL: '/erums/store/dist/assets/images/grey_down_2X.png',
        greyUpURL: '/erums/store/dist/assets/images/grey_up_2X.png',
        storeLookupConfig: {
            storeDetailsAPI: '/api/services/locator/entity/store/',
            zipCodeLookupAPI: '/api/services/locator/store/delivery',
            pickupStoreAPI: '/api/services/locator/store/pickup',
            header: {
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': '28291c6a4d7f436f8a8e279702bd2655'
            }
        },
        disableMyList: {},
        enableShareAd: true,
        enablePrintAd: true,
        printURL: 'https://api.flipp.com/flyerkit/v4.0/publications/',
        printLocale: 'en-US',
        featureFlagURL: '/content/experience-fragments/featureflags/featureflags.caas.json',
        offerDetailsURL: '/abs/perfpub/dce/gallery/J4UProgram1/services/gallery/offers/offerDefinitionByOfferIds?storeId={storeid}',
        adobeImageURL: 'https://images.albertsons-media.com/is/image/ABS/',
        imagePath: '//images.albertsons-media.com/is/image/ABS/${product.id}?$ecom-product-card-${viewport}-jpg$&defaultImage=Not_Available',
        leftNavigation: '/content/experience-fragments/www/for_u/navigation/master.caas.json',
        getPrograms: '/abs/perfpub/ocgp/gamification/internal/programs',
        prizes: "/abs/perfpub/ocgp/gamification/internal/prizes",
        gameActivity: "/abs/perfpub/ocgp/gamification/internal/prizes/game/activity",
        postGameDetails: "/abs/perfpub/ocgp/gamification/internal/gameplay/postgamedetails",
        userGameActivity: "/abs/perfpub/ocgp/gamification/internal/prizes/{uuid}/game/activity",
        redemption: "/abs/perfpub/ocgp/gamification/internal/redemption",
        sweepstakeWinner: "/abs/perfpub/ocgp/gamification/internal/sweepstake/winner",
        userPrizeTransactions: "/abs/perfpub/ocgp/gamification/internal/prizes/{uuid}/transactions",
        programPoints: "/abs/perfpub/ocgp/gamification/internal/program/points",
        optin: "/abs/perfpub/ocgp/gamification/internal/gameplay/optin",
        sweepstakesWinDisplay: "/abs/perfpub/ocgp/gamification/internal/update/sweepstakes/wins",
        getprofileAddressPath: "/abs/perfpub/cnc/ucaservice/api/uca/customers/{customerId}/profile",
        ocrpRewardsTransactionEndpoint: '/abs/perfpub/xapi/ocrp/rewards/transactionhistory',
        ocgpRewardsTransactionEndpoint: '/abs/perfpub/ocgp/gamification/internal/prizes/transactions/history',
        storeResolverZipToCityEndpoint: '/abs/perfpub/xapi/storeresolver/zipcodetocity',
        howItWorks: '/abs/perfpub/ocgp/gamification/internal/update/howitworks',
        gamesAPIHeaders: {
            getProgram: {
                'Accept': 'application/vnd.safeway.v1+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': 'cc2c1f5937d04bef95e98b48c5cf384a',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-id': 'web-portal',
                'x-swy-client-name': 'web-portal',
                'x-swy_banner': '{banner}',
                'cache-control': 'no-cache',
                'client-name': 'webui',
                'Entry': 'web'
            },
            xAPIOcrpRewardsHttpOptions: {
                'Content-Type': 'application/vnd.safeway.v1+json',
                'ocp-apim-subscription-key': '83392d1eda6b4306b1166f6f6a832b2a'
            },
            xAPIOcrpRewardsHttpOptionsV2: {
                'Content-Type': 'application/vnd.safeway.v2+json',
                'ocp-apim-subscription-key': '83392d1eda6b4306b1166f6f6a832b2a'
            },
            xAPIOcgpRewardsHttpOptions: {
                'Entry': 'web',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'ocp-apim-subscription-key': 'cc2c1f5937d04bef95e98b48c5cf384a'
            },
            xAPIstoreResolverHttpOptions: {
                'ocp-apim-subscription-key': '6eb4decfcd01473aa5ee0a690cc39006'
            }
        },
        gamesUCAHeaders: {
            getProfile: {
                'Accept': 'application/vnd.safeway.v3+json',
                'Cache-Control': 'no-cache',
                'Content-Type': 'application/vnd.safeway.v3+json',
                'ocp-Apim-Subscription-Key': '2af9cc1fbd3348f1bf4c47ee480542e5',
                'x-swy-banner': '{banner}',
                'x-swy-client-id': 'web-portal',
                'x-swy-client-name': 'web-portal',
            }
        }
    },
    stage: {
        currentEnv: 'stage',
        displayAds: true,
        sponsoredContentSendChannel: true,
        sponsoredContentSendChannelV2: true,
        fullBannerV2Flag: true,
        showSponsoredText: true,
        topAdType: 'full',
        bottomAdType: 'full',
        aemSponsoredBannerURL: '/content/experience-fragments/www/{banner}/en/generic_content/weeklyads-poc/home.html',
        production: false,
        clientBannerHeader: properties.clientBannerHeader,
        oktaRedirectUri: properties.oktaRedirectUri,
        oktaRedirectUriImplict: properties.oktaRedirectUriImplict,
        oktaRedirectUriConfirmation: properties.oktaRedirectUriConfirmation,
        erumsRedirectCookieName: properties.erumsRedirectCookieName,
        tooltips: properties.tooltips,
        PromoTypeDescription: properties.PromoTypeDescription,
        lastLoginAllowedTime: properties.timer.lastLoginAllowedTime,
        cartUrl: '/erums/cart/',
        checkoutUrl: '/ecom/checkout/modern1/clientcheckout',
        ordersUrl: '/account/orders.html',
        LEFT_NAV_API: '/bin/safeway/ucanavigation?banner={banner}',

        API_HEADERS_GET_STORES: {
            'Ocp-Apim-Subscription-Key': '7bad9afbb87043b28519c4443106db06',
            'x-swy_banner': '{banner}',
            'x-swy-client-id': 'web-portal',
        },
        CHECK_USER_ACTIVE_SESSION: false,
        greyDownURL: '/erums/store/dist/assets/images/grey_down_2X.png',
        greyUpURL: '/erums/store/dist/assets/images/grey_up_2X.png',
        storeLookupConfig: {
            storeDetailsAPI: '/api/services/locator/entity/store/',
            zipCodeLookupAPI: '/api/services/locator/store/delivery',
            pickupStoreAPI: '/api/services/locator/store/pickup',
            header: {
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': '28291c6a4d7f436f8a8e279702bd2655'
            }
        },
        disableMyList: {},
        enableShareAd: true,
        enablePrintAd: true,
        printURL: 'https://api.flipp.com/flyerkit/v4.0/publications/',
        printLocale: 'en-US',
        featureFlagURL: '/content/experience-fragments/featureflags/featureflags.caas.json',
        offerDetailsURL: '/abs/stgpub/dce/gallery/J4UProgram1/services/gallery/offers/offerDefinitionByOfferIds?storeId={storeid}',
        adobeImageURL: 'https://images.albertsons-media.com/is/image/ABS/',
        imagePath: '//images.albertsons-media.com/is/image/ABS/${product.id}?$ecom-product-card-${viewport}-jpg$&defaultImage=Not_Available',
        leftNavigation: '/content/experience-fragments/www/for_u/navigation/master.caas.json',
        getPrograms: '/abs/stgpub/ocgp/gamification/internal/programs',
        prizes: "/abs/stgpub/ocgp/gamification/internal/prizes",
        gameActivity: "/abs/stgpub/ocgp/gamification/internal/prizes/game/activity",
        postGameDetails: "/abs/stgpub/ocgp/gamification/internal/gameplay/postgamedetails",
        userGameActivity: "/abs/stgpub/ocgp/gamification/internal/prizes/{uuid}/game/activity",
        redemption: "/abs/stgpub/ocgp/gamification/internal/redemption",
        sweepstakeWinner: "/abs/stgpub/ocgp/gamification/internal/sweepstake/winner",
        userPrizeTransactions: "/abs/stgpub/ocgp/gamification/internal/prizes/{uuid}/transactions",
        programPoints: "/abs/stgpub/ocgp/gamification/internal/program/points",
        optin: "/abs/stgpub/ocgp/gamification/internal/gameplay/optin",
        sweepstakesWinDisplay: "/abs/stgpub/ocgp/gamification/internal/update/sweepstakes/wins",
        getprofileAddressPath: "/abs/stgpub/cnc/ucaservice/api/uca/customers/{customerId}/profile",
        ocrpRewardsTransactionEndpoint: '/abs/stgpub/xapi/ocrp/rewards/transactionhistory',
        ocgpRewardsTransactionEndpoint: '/abs/stgpub/ocgp/gamification/internal/prizes/transactions/history',
        storeResolverZipToCityEndpoint: '/abs/stgpub/xapi/storeresolver/zipcodetocity',
        howItWorks: '/abs/stgpub/ocgp/gamification/internal/update/howitworks',
        gamesAPIHeaders: {
            getProgram: {
                'Accept': 'application/vnd.safeway.v1+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': 'd44a869ce9dd48fab95acb1e17b65e8f',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-id': 'web-portal',
                'x-swy-client-name': 'web-portal',
                'x-swy_banner': '{banner}',
                'cache-control': 'no-cache',
                'client-name': 'webui',
                'Entry': 'web'
            },
            xAPIOcrpRewardsHttpOptions: {
                'Content-Type': 'application/vnd.safeway.v1+json',
                'ocp-apim-subscription-key': '7a912a136fdf4fdb84b3838dbcb677fb'
            },
            xAPIOcrpRewardsHttpOptionsV2: {
                'Content-Type': 'application/vnd.safeway.v2+json',
                'ocp-apim-subscription-key': '7a912a136fdf4fdb84b3838dbcb677fb'
            },
            xAPIOcgpRewardsHttpOptions: {
                'Entry': 'web',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'ocp-apim-subscription-key': 'd44a869ce9dd48fab95acb1e17b65e8f'
            },
            xAPIstoreResolverHttpOptions: {
                'ocp-apim-subscription-key': '7bad9afbb87043b28519c4443106db06'
            }
        },
        gamesUCAHeaders: {
            getProfile: {
                'Accept': 'application/vnd.safeway.v3+json',
                'Cache-Control': 'no-cache',
                'Content-Type': 'application/vnd.safeway.v3+json',
                'ocp-Apim-Subscription-Key': '38c2e3420b8b450d9ffd5564ff22c4f0',
                'x-swy-banner': '{banner}',
                'x-swy-client-id': 'web-portal',
                'x-swy-client-name': 'web-portal',
            }
        }
    },
    prod: {
        currentEnv: 'prod',
        displayAds: true,
        sponsoredContentSendChannel: true,
        sponsoredContentSendChannelV2: true,
        fullBannerV2Flag: true,
        showSponsoredText: true,
        topAdType: 'full',
        bottomAdType: 'full',
        aemSponsoredBannerURL: '/content/experience-fragments/www/{banner}/en/generic_content/weeklyads-poc/home.html',
        production: false,
        clientBannerHeader: properties.clientBannerHeader,
        oktaRedirectUri: properties.oktaRedirectUri,
        oktaRedirectUriImplict: properties.oktaRedirectUriImplict,
        oktaRedirectUriConfirmation: properties.oktaRedirectUriConfirmation,
        erumsRedirectCookieName: properties.erumsRedirectCookieName,
        tooltips: properties.tooltips,
        PromoTypeDescription: properties.PromoTypeDescription,
        lastLoginAllowedTime: properties.timer.lastLoginAllowedTime,
        cartUrl: '/erums/cart/',
        checkoutUrl: '/ecom/checkout/modern1/clientcheckout',
        ordersUrl: '/account/orders.html',
        LEFT_NAV_API: '/bin/safeway/ucanavigation?banner={banner}',

        API_HEADERS_GET_STORES: {
            'Ocp-Apim-Subscription-Key': '7bad9afbb87043b28519c4443106db06',
            'x-swy_banner': '{banner}',
            'x-swy-client-id': 'web-portal',
        },
        CHECK_USER_ACTIVE_SESSION: false,
        greyDownURL: '/erums/store/dist/assets/images/grey_down_2X.png',
        greyUpURL: '/erums/store/dist/assets/images/grey_up_2X.png',
        storeLookupConfig: {
            storeDetailsAPI: '/api/services/locator/entity/store/',
            zipCodeLookupAPI: '/api/services/locator/store/delivery',
            pickupStoreAPI: '/api/services/locator/store/pickup',
            header: {
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': '28291c6a4d7f436f8a8e279702bd2655'
            }
        },
        disableMyList: {},
        enableShareAd: true,
        enablePrintAd: true,
        printURL: 'https://api.flipp.com/flyerkit/v4.0/publications/',
        printLocale: 'en-US',
        featureFlagURL: '/content/experience-fragments/featureflags/featureflags.caas.json',
        offerDetailsURL: '/abs/pub/dce/gallery/J4UProgram1/services/gallery/offers/offerDefinitionByOfferIds?storeId={storeid}',
        adobeImageURL: 'https://images.albertsons-media.com/is/image/ABS/',
        imagePath: '//images.albertsons-media.com/is/image/ABS/${product.id}?$ecom-product-card-${viewport}-jpg$&defaultImage=Not_Available',
        leftNavigation: '/content/experience-fragments/www/for_u/navigation/master.caas.json',
        getPrograms: '/abs/pub/ocgp/gamification/internal/programs',
        prizes: "/abs/pub/ocgp/gamification/internal/prizes",
        gameActivity: "/abs/pub/ocgp/gamification/internal/prizes/game/activity",
        postGameDetails: "/abs/pub/ocgp/gamification/internal/gameplay/postgamedetails",
        userGameActivity: "/abs/pub/ocgp/gamification/internal/prizes/{uuid}/game/activity",
        redemption: "/abs/pub/ocgp/gamification/internal/redemption",
        sweepstakeWinner: "/abs/pub/ocgp/gamification/internal/sweepstake/winner",
        userPrizeTransactions: "/abs/pub/ocgp/gamification/internal/prizes/{uuid}/transactions",
        programPoints: "/abs/pub/ocgp/gamification/internal/program/points",
        optin: "/abs/pub/ocgp/gamification/internal/gameplay/optin",
        sweepstakesWinDisplay: "/abs/pub/ocgp/gamification/internal/update/sweepstakes/wins",
        getprofileAddressPath: "/abs/pub/cnc/ucaservice/api/uca/customers/{customerId}/profile",
        ocrpRewardsTransactionEndpoint: '/abs/pub/xapi/ocrp/rewards/transactionhistory',
        ocgpRewardsTransactionEndpoint: '/abs/pub/ocgp/gamification/internal/prizes/transactions/history',
        storeResolverZipToCityEndpoint: '/abs/pub/xapi/storeresolver/zipcodetocity',
        howItWorks: '/abs/pub/ocgp/gamification/internal/update/howitworks',
        gamesAPIHeaders: {
            getProgram: {
                'Accept': 'application/vnd.safeway.v1+json',
                'banner': '{banner}',
                'ocp-apim-subscription-key': '404e1cfeef26443ba8a37269e0b3fe73',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'x-swy-client-id': 'web-portal',
                'x-swy-client-name': 'web-portal',
                'x-swy_banner': '{banner}',
                'cache-control': 'no-cache',
                'client-name': 'webui',
                'Entry': 'web'
            },
            xAPIOcrpRewardsHttpOptions: {
                'Content-Type': 'application/vnd.safeway.v1+json',
                'ocp-apim-subscription-key': 'daedbc8e06814b3f857bfe1f00270865'
            },
            xAPIOcrpRewardsHttpOptionsV2: {
                'Content-Type': 'application/vnd.safeway.v2+json',
                'ocp-apim-subscription-key': 'daedbc8e06814b3f857bfe1f00270865'
            },
            xAPIOcgpRewardsHttpOptions: {
                'Entry': 'web',
                'Content-Type': 'application/vnd.safeway.v1+json',
                'ocp-apim-subscription-key': '404e1cfeef26443ba8a37269e0b3fe73'
            },
            xAPIstoreResolverHttpOptions: {
                'ocp-apim-subscription-key': '7bad9afbb87043b28519c4443106db06'
            }
        },
        gamesUCAHeaders: {
            getProfile: {
                'Accept': 'application/vnd.safeway.v3+json',
                'Cache-Control': 'no-cache',
                'Content-Type': 'application/vnd.safeway.v3+json',
                'ocp-Apim-Subscription-Key': '9e38e3f1d32a4279a49a264e0831ea46',
                'x-swy-banner': '{banner}',
                'x-swy-client-id': 'web-portal',
                'x-swy-client-name': 'web-portal',
            }
        }
    }
};
